module.exports = "/_next/static/images/UniFi-ed09c690accf660ba7c368d3f796e634.png";